import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App/index';
import * as serviceWorker from './serviceWorker';
import { store } from './store/store';
import config from './config';
import './assets/scss/style.scss';
import './assets/fontawesome-free-6.1.1-web/fontawesome-free-6.1.1-web/css/fontawesome.css';
import './assets/fontawesome-free-6.1.1-web/fontawesome-free-6.1.1-web/css/brands.css';
import './assets/fontawesome-free-6.1.1-web/fontawesome-free-6.1.1-web/css/solid.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import './index.css';
import { AuthContextProvider } from './utils/firebase';

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <AuthContextProvider>
        <BrowserRouter basename={config.basename}>
          <ToastContainer />
          <App />
        </BrowserRouter>
      </AuthContextProvider>
    </Provider>
  </React.StrictMode>
);
ReactDOM.render(app, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
